import {
  DEFAULT_PHONE_ISO_CODE,
  getDialCodeByIsoCode,
} from '../data/countries';
import { config } from '../config';
import { getUtmParams } from './utm';

export interface WebsiteFormPayload {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  phoneIsoCode: number | undefined;
  emailAddress: string;
  organisation: string;
  location: string;
  causeInterestedIn: string;
  briefMessage: string;
}

export function resolvePhoneIsoCode(phoneIsoCode: string): number | undefined {
  return (
    getDialCodeByIsoCode(phoneIsoCode) ??
    getDialCodeByIsoCode(DEFAULT_PHONE_ISO_CODE)
  );
}

export async function submitWebsiteForm(
  payload: WebsiteFormPayload
): Promise<void> {
  const response = await fetch(config.apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...payload,
      ...getUtmParams(),
    }),
  });

  if (!response.ok) {
    throw new Error('Form submission failed');
  }
}
